import { isProductionMode } from "./consts"

export const getFullImageUrl = (url: string) => {
  let baseUrl = "https://app-stag.babele.co"

  if (import.meta.env.VITE_PROD_NAME === "ms") {
    if (
      !url.startsWith("http") &&
      !url.startsWith("/static") &&
      url.toLocaleLowerCase().includes("uploads")
    ) {
      baseUrl = "https://assets.babele.co"
    }
  } else {
    if (isProductionMode()) {
      baseUrl = "https://assets-prod.babele.co"
    }
  }

  if (url.startsWith("http")) return url

  if (url.startsWith("/Images")) {
    return `${baseUrl}${url}`
  }

  if (url.startsWith("Images")) {
    return `${baseUrl}/${url}`
  }

  if (url.startsWith("\\Images")) {
    return `${baseUrl}/${url}`
  }

  if (url.startsWith("/static")) {
    // @TODO this is for the old urls from the old app
    return `/src${url}`.replace("png", "webp")
  }

  return url
}

export const fixImageUrlsInHtml = (html: string): string => {
  if (!html || !html.includes("img")) return html
  const wrapper = document.createElement("div")
  wrapper.innerHTML = html
  const imgs = wrapper.getElementsByTagName("img")
  for (let i = 0; i < imgs.length; i++) {
    const img = imgs[i]
    const src = img.getAttribute("src")
    if (src) {
      img.setAttribute("src", getFullImageUrl(src))
    }
  }
  return wrapper.innerHTML
}

export const getInitials = (name: string): string => {
  if (!name || !name.trim()) {
    return ""
  }

  const nameParts = name
    .trim()
    .split(" ")
    ?.filter((str) => str !== "")

  if (nameParts.length === 1) {
    return nameParts[0].charAt(0).toUpperCase()
  }
  return (
    nameParts[0].charAt(0).toUpperCase() + nameParts[1].charAt(0).toUpperCase()
  )
}
